import React from 'react';
import { FormGroup, FormInput, Type } from '@spotify-internal/encore-creator-web';
import { PodcastModalBody } from '../../Shared/PodcastModal';
import { FormattedMessage } from 'react-intl';

interface Props {
  podcastRSSLink: string;
}

export function ConfirmNewSubmission(props: Props) {
  const { podcastRSSLink } = props;

  return (
    <PodcastModalBody data-testid="confirm-rss-feed">
      <Type as="h1" variant={Type.heading2}>
        <FormattedMessage
          id="add-podcast.new-submission-title"
          defaultMessage="OK. Let’s add your podcast to Spotify."
        />
      </Type>
      <Type as="p" variant={Type.body1}>
        <FormattedMessage
          id="add-podcast.new-submission-instructions"
          defaultMessage="Confirm that this podcast is yours and continue by clicking <strong>next</strong>."
          values={{
            strong: (...chunks) => <strong>{chunks}</strong>,
          }}
        />
      </Type>
      <FormGroup
        label={
          <FormattedMessage
            id="add-podcast.new-submission-feed-link"
            defaultMessage="Link to RSS feed"
          />
        }
        labelFor="podcastRSSLink"
      >
        <FormInput id="podcastRSSLink" value={podcastRSSLink} disabled={true} />
      </FormGroup>
    </PodcastModalBody>
  );
}
